<template lang='pug'>
    v-dialog(
        v-model="dialog" 
        persistent max-width="500px"
    )
        template(v-slot:activator="{ on, attrs }")
            v-btn(
                color="red" 
                style="float: right; margin-right:10px"
                dark
                class="elevation-0"
                @click="showDialog"
            )
                | Export Laporan

        v-card
            v-card-title(class="headline grey lighten-2") Export Laporan
            v-card-text
                v-row(class="mt-5") 

                    v-col(cols="6")
                        v-dialog(
                            ref="dialogStart"
                            v-model="modal1"
                            :return-value.sync="startDate"
                            persistent
                            width="290px"
                        )
                            template(v-slot:activator="{ on, attrs }")
                                v-text-field(
                                    v-model="startDate"
                                    label="Dari"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                )
                            v-date-picker(
                                v-model="startDate"
                                :max="getMaxStartDate"
                                scrollable
                            )
                                v-spacer
                                v-btn(
                                    text
                                    color="primary"
                                    @click="modal1 = false"
                                ) Cancel
                            
                                v-btn(
                                    text
                                    color="primary"
                                    @click="$refs.dialogStart.save(startDate)"
                                ) OK

                    v-col(cols="6")
                        v-dialog(
                            ref="dialogEnd"
                            v-model="modal2"
                            :return-value.sync="endDate"
                            persistent
                            width="290px"
                        )
                            template(v-slot:activator="{ on, attrs }")
                                v-text-field(
                                    v-model="endDate"
                                    label="Ke"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                )
                            v-date-picker(
                                v-model="endDate"
                                :max="dateNow"
                                scrollable
                            )
                                v-spacer
                                v-btn(
                                    text
                                    color="primary"
                                    @click="modal2 = false"
                                ) Cancel
                            
                                v-btn(
                                    text
                                    color="primary"
                                    @click="saveEndDate(endDate)"
                                ) OK

            v-card-actions(class="pa-6")
                v-spacer
                v-btn(
                    depressed 
                    class="pl-4 pr-4"
                    @click="closeDialog"
                ) Cancel
                
                v-btn(
                    color="blue"
                    dark 
                    depressed 
                    class="pl-4 pr-4"
                    @click="submit"
                ) Submit
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
export default {
  name: 'ExportLaporan',
  data: () => ({
    dateNow: '',
    dialog: false,
    startDate: '',
    modal1: false,
    modal2: false,
    endDate: '',
  }),
  props: {
    title: String
  },
  computed: {
    ...mapState(['API_URL',"dataUsers"]),
    getMaxStartDate() {
        return this.endDate
    },
  },
  methods: {
    submit() {
      this.$store.state.loader = true;

      let URL = `${this.API_URL}/v1/requests/download-excel`

      if ( this.title == 'My Permit' ) {
        URL = `${URL}?email=${this.dataUsers.email}&startdate=${this.startDate}&enddate=${this.endDate}`;
      } else {
        URL = `${URL}?startdate=${this.startDate}&enddate=${this.endDate}`;
      }

      axios.head(URL)
        .then((response) => {
            const statusCode = response.status;
            if (statusCode === 404 || statusCode === 500) {
                this.$store.state.loader = false;
                //TODO: Perlu alert handle error
            } else {
                this.$store.state.loader = false;
                this.download(URL);
                // window.location.href = URL;
                this.dialog = false;
            }      
        })
        .catch(() => {
           this.$store.state.loader = false;
           //TODO: Perlu alert handle error
        })
    },
    async download(fileUrl) {
        const response = await axios.get(fileUrl, {
            responseType: 'blob', // Important to set the response type to blob
        });

        // Create a blob URL for the file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        
        // Create a link element
        const a = document.createElement('a');
        a.href = url;
        a.download = `lapran ${this.startDate} sd ${this.endDate}.xlsx`; // Set the desired file name
        document.body.appendChild(a);
        a.click(); // Programmatically click the link to trigger download
        a.remove(); // Remove the link after triggering download
        window.URL.revokeObjectURL(url); // Clean up
    },
    showDialog() {
        const currentDate = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
        this.dateNow = currentDate;
        this.startDate = currentDate;
        this.endDate = currentDate;
        this.dialog = true
    },
    closeDialog() {
        this.dateNow = ''
        this.startDate = ''
        this.endDate = ''
        this.dialog = false
    },
    saveEndDate(value) {
        if ( this.startDate > value ) {
            this.startDate = value
        }
        this.endDate = this.$refs.dialogEnd.save(value)
    },
  }
};
</script>
